// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Facets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    registeredDateRange: t.struct({
        dateRange: t.struct({
            from: t.maybe(t.Number),
            to: t.maybe(t.Number)
        }),
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    }),
    statusFacet: t.struct({
        allowedStatuses: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedStatuses: t.list(KeyValuePair)
    })
}, 'Facets');

export const getDefaultState = () =>
    new Facets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        registeredDateRange: {
            dateRange: {
                from: null,
                to: null
            },
            maxDate: null,
            minDate: null

        },
        statusFacet: {
            allowedStatuses: [],
            isInitialLoad: true,
            selectedStatuses: []
        }
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/product/search/state/facets.js